import { createClient } from '@supabase/supabase-js';
import { cookieStorage, migrateLegacySession } from './sessionStorage';

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
if (!url || !publishableKey) throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY');

// One-time copy of a pre-existing session from localStorage into the
// cross-subdomain cookie store, before the client is created below.
migrateLegacySession();

export const supabase = createClient(url, publishableKey, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: cookieStorage,
  },
});

export default supabase;
